module.exports = __webpack_public_path__ + "guide-notice04.70931.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-notice04.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-notice04.svg
// module chunks = main